import { Grid } from "antd";
import { BarChart } from "@mui/x-charts";
import React, { useEffect, useState } from "react";

export function BarChartV1({
  data,
  lineColors,
  serverKeys,
  timeInterval,
  metrics,
}: any) {
  const [labels, setLabels] = useState<string[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [legendItems, setLegendItems] = useState<any[]>([]);

  const { useBreakpoint } = Grid;

  const screens = useBreakpoint();

  const labelFontSize = screens.xxl
    ? 14
    : screens.xl
      ? 13
      : screens.lg
        ? 12
        : 10;
  const tickFontSize = screens.xxl ? 14 : screens.xl ? 12 : screens.lg ? 10 : 8;

  useEffect(() => {
    const generateData = () => {
      const generatedLabels: string[] = [];
      const generatedData: any[] = [];
      for (let i = 1; i < data.length; i++) {
        const startTime = new Date(data[i - 1].timeStamps);
        const endTime = new Date(data[i].timeStamps);

        const timeLabel = `${("0" + startTime.getHours()).slice(-2)}:${(
          "0" + startTime.getMinutes()
        ).slice(-2)} - ${("0" + endTime.getHours()).slice(-2)}:${(
          "0" + endTime.getMinutes()
        ).slice(-2)}`;
        const dateLabel = `${endTime.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
        })}`;

        const day = String(startTime.getDate()).padStart(2, "0"); // Get day and pad with leading zero if necessary
        const month = String(startTime.getMonth() + 1).padStart(2, "0"); // Get month (Note: Months are zero-based, so add 1) and pad with leading zero if necessary
        const formattedDate = `${day}/${month}`;

        if (timeInterval === "1 week") {
          generatedLabels.push(`${formattedDate}`);
        } else {
          generatedLabels.push(`${timeLabel}\n${formattedDate}`);
        }

        const newObj: any = {
          timeStamps: `${timeLabel}\n${dateLabel}`,
        };

        if (serverKeys && serverKeys.length > 0) {
          serverKeys.forEach((key: any, index: any) => {
            newObj[key] = data[i][key];
          });
        }

        generatedData.push(newObj);
      }
      return { labels: generatedLabels, data: generatedData };
    };

    if (data) {
      const { labels, data } = generateData();
      setLabels(labels);
      setChartData(data);
    }

    const items = Object.keys(lineColors).map((key: string) => ({
      color: lineColors[key],
      key,
    }));
    setLegendItems(items);
  }, [data]);

  let series;
  if (!serverKeys || serverKeys.length === 0) {
    series = [{ data: chartData.map(() => 0), label: metrics, stack: "A" }];
  } else {
    series = serverKeys?.map((key: string, index: number) => ({
      data: chartData.map((dataItem) => {
        // If the metric is "Processing Time", add "secs" to the value
        if (metrics === "Processing Time") {
          return dataItem[key] !== 0 && dataItem[key] !== undefined
            ? dataItem[key]?.toFixed(2)
            : 0;
        } else {
          return dataItem[key];
        }
      }), // Map chartData[key] as an array
      label: key,
      stack: "A",
      color: `${lineColors[index]}`, // Add opacity to the color (66 represents 40% opacity)
    }));
  }

  const tickValues = [0, 5, 10, 15, 20]; // Example custom tick values
  const dummyLabels = [""];
  const dummySeries = [
    {
      data: [0],
      label: "",
      stack: "A",
      color: "#006AB3",
    },
  ];

  const finalLabels = labels.length > 0 ? labels : dummyLabels;
  const finalSeries = labels.length > 0 ? series : dummySeries;

  return (
    <>
      {finalLabels.length > 0 && (
        <BarChart
          title="Your Chart Title"
          xAxis={[
            {
              scaleType: "band",
              data: finalLabels,
              tickLabelStyle: {
                fontSize: tickFontSize,
              },
            },
          ]}
          yAxis={[
            {
              scaleType: "linear",
              label: metrics === "Processing Time" ? "Time(s)" : "Count", // Replace with your desired Y-axis label
              labelStyle: { fontWeight: "bold" },
              tickLabelStyle: {
                fontSize: tickFontSize,
              },
            },
          ]}
          series={finalSeries}
          slotProps={{
            legend: {
              labelStyle: {
                fontSize: labelFontSize,
              },
              itemMarkWidth: 10,
              itemMarkHeight: 10,
            },
          }}
        />
      )}
    </>
  );
}
